import equal from 'fast-deep-equal';

const getMapOfFontPairs = (fontPairs) =>
  fontPairs.reduce((accum, fontPair) => {
    const accumCopy = { ...accum };
    accumCopy[fontPair.id] = fontPair;
    return accumCopy;
  }, {});

const getCustomFontPairsToUpdate = (initialCustomFontPairs, currentCustomFontPairs) => {
  if (equal(initialCustomFontPairs, currentCustomFontPairs)) return [];

  const initialCustomFontPairsMap = getMapOfFontPairs(initialCustomFontPairs);
  const initialIds = Object.keys(initialCustomFontPairsMap);

  const currentCustomFontPairsMap = getMapOfFontPairs(currentCustomFontPairs);
  const currentIds = Object.keys(currentCustomFontPairsMap);

  const intersection = initialIds.filter((element) => currentIds.includes(element));

  return intersection
    .map((id) => {
      const initialValue = initialCustomFontPairsMap[id];
      const currentValue = currentCustomFontPairsMap[id];
      if (!equal(initialValue, currentValue)) return currentValue;
      return null;
    })
    .filter(Boolean);
};

export default getCustomFontPairsToUpdate;
